import { render } from "./EmoticonOutline.vue?vue&type=template&id=0f829500"
import script from "./EmoticonOutline.vue?vue&type=script&lang=js"
export * from "./EmoticonOutline.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__